import React from "react";
import { useState } from "react";
import useApiMantenimientoStp from "../../api/catalogos/useApiMantenimientoStp";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import { Sidebar } from "primereact/sidebar";
import MantenimientoStpDetalle from "./MantenimientoStpDetalle";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import agGridHelper from "../../shared/ag-grid-helper";
import Filtro from "../../shared/componentes/filtro";
import FiltroMantenimientoStp from './FiltroMantenimientoStp';
import { getSessionState } from "../../hooks/useSessionState";
import useSeguridad from "../../Seguridad/useSeguridad";
import constantes from "../constantes";

const MantenimientoStp = () => {
    const seguridad = useSeguridad();
    const soloLectura = !seguridad.esEditable(constantes.menus.conceptosCobro);
    const filtroKey = 'FiltroMantenimientoStp';
    const [datos, setDatos] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [conceptoId, setConceptoId] = useState(false);
    const api = useApiMantenimientoStp();

    async function nuevo() {
        setSidebarVisible(true);
        setConceptoId(0);
    }

    async function onSave() {
        setSidebarVisible(false);
        await buscar();
    }

    const onGridReady = async (params) => {
        setGridApi(params.api);
    };

    async function buscar(filtro, paramsApi) {
        agGridHelper.showLoad(gridApi, paramsApi, true);
        setDatos(await api.filtrar(filtro ?? getSessionState(filtroKey)));
        agGridHelper.hideLoad(gridApi, paramsApi, false);
    };

    const editConcepto = (id) => {
        setSidebarVisible(true);
        setConceptoId(id);
    };

    const ButtonsHeader = () => {
        return (
            <div className="ag-grid header-icons">
                {!soloLectura &&
                    <ButtonIcon title="Agregar" className={'grid-action'} iconName={'MdAddBox'} onClick={nuevo} />
                }
            </div>
        );
    }

    const rowButtons = ({ data, rowIndex, api, context }) => (
        <div className="ag-grid row-icons">
            <ButtonIcon title={'Editar'} iconName={'FaRegEdit'} onClick={() => context.editConcepto(data.id)} />
        </div>
    );

    return (
        <>
            <Sidebar visible={sidebarVisible} position="right" dismissable={false}
                className="p-sidebar-md" onHide={() => setSidebarVisible(false)}>
                <MantenimientoStpDetalle conceptoId={conceptoId} onSave={onSave}
                    close={() => setSidebarVisible(false)} soloLectura={soloLectura} />
            </Sidebar>
            <Filtro filtroKey={filtroKey} handleSubmit={buscar} classButtons="field-iconos btn-group" gridApi={gridApi}>
                <FiltroMantenimientoStp />
            </Filtro>
            <div className="ag-theme-balham grid-principal com-conceptosCobro">
                <AgGridReact
                    enableSorting={true}
                    enableFilter={true}
                    pagination={true}
                    className=""
                    frameworkComponents={{
                        rowButtons: rowButtons,
                        gotoDetail: agGridHelper.GoToDetailFormatter,
                        buttonsHeader: ButtonsHeader,
                        dateFormatter: agGridHelper.DateFormatter,
                        imageFormatter: agGridHelper.ImageFormatter
                    }}
                    onGridReady={onGridReady}
                    rowData={datos}
                    overlayLoadingTemplate={agGridHelper.loadingOverlay}
                    defaultColDef={agGridHelper.defaultColumns}
                    rowHeight={35}
                    context={{
                        editConcepto: editConcepto
                    }}>
                    <AgGridColumn field="fechaInicio" headerName="Fecha Inicio"  cellRenderer="dateFormatter" text cellStyle={{ textAlign: "left" }} />
                    <AgGridColumn field="fechaFin" headerName="Fecha Fin"   cellRenderer="dateFormatter" text cellStyle={{ textAlign: "left" }} />
                    <AgGridColumn field="finalizado" headerName="Finalizado" text cellStyle={{ textAlign: "left" }} />
                    <AgGridColumn maxWidth={80}
                        headerName="VER"
                        cellRenderer="rowButtons"
                        pinned={'right'}
                        cellClass={'left'}
                        headerComponent="buttonsHeader" />
                </AgGridReact>
            </div>
        </>
    )
};

export default MantenimientoStp;